import { Alert, Button, Popover, Radio, Skeleton } from "antd";
import React, { useEffect, useState } from "react";
import Style from "./FactureByID.module.css";
import { useHistory, useParams } from "react-router-dom";
import { errorToast, succToast } from "../../../../Toast/Toast";
import {
  facturePayApi,
  getFactureByIdAPI,
} from "../../../../Api/BarestServices";
import { separate } from "../../../../Seprate/Seprate";
const FactureByID = () => {
    const history=useHistory()
  const param = useParams();
  const [facturDataState, setFacturDataState] = useState();
  const [paymentTypeState, setPaymentTypeState] = useState("pgw");
  const [loadingState, setLoadingState] = useState(false);
  useEffect(() => {
    getFactureHandler();
  }, []);
  const getFactureHandler = () => {
    setLoadingState(true);
    getFactureByIdAPI(window.location.pathname.split("/")[2], (succ, res) => {
      if (succ) {
        if (res.status === 1) {
          setFacturDataState(res.facture.length!==0?[res.facture]:res.facture);
          setLoadingState(false);
        } else {
          errorToast(res.message);
          setLoadingState(false);
        }
      } else {
        setLoadingState(false);
        console.error(res);
      }
    });
  };
  const statusHandler = (status) => {
    switch (status) {
      case "1":
        return "پرداخت شده";
      case "-1":
        return "کنسل شده";
      case "0":
        return "پرداخت نشده";

      default:
        break;
    }
  };
  const payFacturHandler = () => {
    setLoadingState(true);
    const info = {
      id: param?.id,
      payment_type: paymentTypeState,
    };
    facturePayApi(info, (res) => {
      if (res.status === 1) {
        succToast("درخواست شما ثبت شد");
        if (paymentTypeState === "pgw") {
          window.open(res.link, "_self");
        }
        setTimeout(() => {
          window.location.reload()
        }, 1000);
        setLoadingState(false);
      } else {
        errorToast(res.message);
        setLoadingState(false);
      }
    });
  };
  const paymentType = (
    <div className={Style.paymentHolder}>
      <Radio.Group
        onChange={(e) => setPaymentTypeState(e.target.value)}
        value={paymentTypeState}
        style={{
          display: "flex",
          flexDirection: "column",
          direction: "rtl",
          width: "100%",
        }}
        options={[
          { value: "wallet", label: "کیف پول" },
          { value: "pgw", label: "پرداخت آنلاین" },
          { value: "debt", label: "کمک برست" },
        ]}
      />
      <Button
        type="primary"
        onClick={payFacturHandler}
        loading={loadingState}
        disabled={loadingState}
      >
        پرداخت
      </Button>
    </div>
  );
  console.log(facturDataState)
  return (
    <>
      {facturDataState===undefined ?(
        <Skeleton
          active
          style={{ maxWidth: "450px", margin: "3rem auto", width: "100%" }}
        />
      )
      :facturDataState?.length === 0 ? (
        <div className={Style.ComponentHolder}>
          <Alert type="error" description="همچین فاکتوری یا وجود ندارد یا منقضی شده!" style={{direction:'rtl',marginBottom:'2rem',width:'100%'}} showIcon/>
          <button className={Style.buttonHolder} onClick={()=>history.push('/')}>برگشت به برنامه</button>
        </div>
      ) : (
            <div className={Style.ComponentHolder}>
            <img src="/Assets/Images/payment/factorpayment.svg" alt="factor" className={Style.ImageFactor}/>
        <section className={Style.ItemHolder}>
          <div className={Style.FactorTopPart}>
            <div>
              <p>
                شناسه فاکتور: <span>{facturDataState[0]?.id}</span>
              </p>
              <p>
                مبلغ فاکتور:{" "}
                <span>{separate(facturDataState[0]?.amount)} تومان</span>
              </p>
            </div>
            <div>
              <p>
                وضعیت:<span>{statusHandler(facturDataState[0]?.status)}</span>
              </p>
              {facturDataState[0]?.status === "0" ? (
                <Popover
                  overlayInnerStyle={{ direction: "rtl" }}
                  destroyTooltipOnHide={true}
                  content={paymentType}
                  title="نوع پرداخت رو انتخاب کنید"
                  trigger="click"
                >
                  <button className={Style.buttonHolder} disabled={loadingState}>پرداخت</button>
                </Popover>
              ) : (
                <></>
              )}
            </div>
          </div>
          {facturDataState[0]?.description && (
            <p className={Style.FactorBottomPart}>
              توضیحات فاکتور: {facturDataState[0]?.description}
            </p>
          )}
        </section></div>
      )}
    </>
  );
};

export default FactureByID;
